import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

export function Paths() {
    const [cats, setCats] = useState([]);
    const [services, setServices] = useState([]);
    useEffect(() => { api.get("/services").then((r) => { setCats(r.data.categories); setServices(r.data.services); }).catch(() => {}); }, []);
    return (
        <section id="paths" className="scroll-mt-20 bg-[#FBFCFE] px-5 py-20 lg:px-8 lg:py-28" data-testid="paths-section">
            <div className="mx-auto max-w-7xl">
                <div className="reveal grid gap-6 lg:grid-cols-[1fr_auto] lg:items-end">
                    <div>
                        <div className="si-eyebrow">What we do</div>
                        <h2 className="mt-4 font-display text-4xl font-semibold tracking-[-0.035em] text-navy sm:text-5xl">Start it. Run it. Protect it. <span className="font-serif-accent text-ocean">Fund it.</span></h2>
                    </div>
                    <p className="max-w-md text-base text-slate-600 lg:text-right">Six service lines, one accountable team. Every engagement begins with a free consultation and a written scope.</p>
                </div>
                <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {cats.map((c, i) => (
                        <Link key={c.id} to={`/services#${c.id}`} data-testid={`path-${c.id}`} style={{ "--d": `${i * 80}ms` }} className="si-photo-card group relative block overflow-hidden text-left !aspect-[4/4.2]">
                            <img src={c.image} alt="" loading="lazy" className="si-zoom absolute inset-0 h-full w-full object-cover" />
                            <div className="si-photo-card-scrim absolute inset-0" aria-hidden="true" />
                            <div className="relative flex h-full flex-col justify-end p-7">
                                <div className="text-[11px] font-bold uppercase tracking-[0.16em] text-teal-light">{c.tag}</div>
                                <h3 className="mt-2 font-display text-3xl font-semibold tracking-[-0.03em] text-white">{c.name}</h3>
                                <p className="mt-2 text-[14.5px] leading-relaxed text-slate-200">{c.desc}</p>
                                <ul className="mt-4 flex flex-wrap gap-1.5">
                                    {services.filter((s) => s.category === c.id).slice(0, 4).map((s) => <li key={s.slug} className="rounded-full border border-white/20 bg-white/10 px-2.5 py-1 text-[11px] font-semibold text-white backdrop-blur">{s.name}</li>)}
                                </ul>
                                <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-white">See all <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
